import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-comparison-xr',
    templateUrl: './comparison-xr.component.html',
    styleUrls: ['./comparison-xr.component.scss'],
    standalone: false
})
export class ComparisonXrComponent {

}
